import { Controller } from "@hotwired/stimulus"
import * as bootstrap from "bootstrap"

export default class extends Controller {
  static targets = ["content", "toggle", "spinner"]
  static values = { ledgerId: Number }

  async loadContent(event) {
    event.preventDefault()

    const toggle = this.toggleTarget
    const container = this.contentTarget

    // Close other open dropdowns
    document.querySelectorAll('[data-pc-drilldown-target="toggle"]').forEach(t => {
      if (t === toggle) return
      const inst = bootstrap.Dropdown.getInstance(t)
      if (inst) inst.hide()
    })

    const dropdown = bootstrap.Dropdown.getOrCreateInstance(toggle)

    const frame = container
    const isFirstLoad = !frame.dataset.loaded

    if (isFirstLoad) {
      // Show spinner only on first load
      this.spinnerTarget.classList.remove("d-none")

      const journalLineIds = toggle.dataset.journalLines // e.g. data-journal-lines="[1,2,3]"
      const journal_line_params = journalLineIds ? `journal_lines[]=${journalLineIds.split(',').join('&journal_lines[]=')}` : ""

      const pipelineOccurrenceIds = toggle.dataset.pipelineOccurrences // e.g. data-pipeline-occurrences="[1,2,3]"
      const pipeline_occurrence_params = pipelineOccurrenceIds ? `pipeline_occurrences[]=${pipelineOccurrenceIds.split(',').join('&pipeline_occurrences[]=')}` : ""

      const ledger_param = `ledger_id=${this.ledgerIdValue}`
      const uncategorisedFrom = toggle.dataset.uncategorisedFrom
      const uncategorisedThrough = toggle.dataset.uncategorisedThrough
      const uncategorised_params = uncategorisedFrom && uncategorisedThrough
        ? `uncategorised_from=${encodeURIComponent(uncategorisedFrom)}&uncategorised_through=${encodeURIComponent(uncategorisedThrough)}`
        : ""
      const queryString = [ledger_param, journal_line_params, pipeline_occurrence_params, uncategorised_params].filter(Boolean).join('&')

      frame.src = `/portfolio_control/drilldowns?${queryString}`
      frame.dataset.loaded = true

      // Hide spinner when frame loads
      frame.addEventListener("turbo:frame-load", () => {
        this.spinnerTarget.classList.add("d-none")
        dropdown.show()
      }, { once: true })
    }
    else {
          dropdown.show()
    }

    // Click-away to close (always attach)
    const handleClickOutside = (e) => {
      if (!this.element.contains(e.target)) {
        dropdown.hide()
        document.removeEventListener("click", handleClickOutside, true)
      }
    }
    document.addEventListener("click", handleClickOutside, true)
  }
}
